module.exports = __webpack_public_path__ + "img/howtoapply_sm.f29fe844.png";